export default "__VITE_ASSET__Bqh35MA6__"